import { MenuItem } from '@mui/material'
import { FormField } from 'global/components/Form'
import { useEffect, useState } from 'react'
import { FuncoesAvaliacao, funcoesAvaliacao } from 'service/api'

interface IProps {
    required?: boolean
}

export function SelectFunction({ required }: IProps) {
    const [funcoes, setFuncoes] = useState<FuncoesAvaliacao[]>([])

    useEffect(() => {
        funcoesAvaliacao
            .get()
            .then(res => setFuncoes(res ?? []))
            .catch(() => setFuncoes([]))
    }, [])

    if (!funcoes?.length) {
        return (
            <FormField
                required={required}
                name="funcaoId"
                label="Função"
                disabled
            />
        )
    }

    return (
        <FormField required={required} name="funcaoId" select label="Função">
            {funcoes.map((funcao, id) => (
                <MenuItem key={id} value={funcao.id}>
                    {funcao.nome}
                </MenuItem>
            ))}
        </FormField>
    )
}
